module.exports = __webpack_public_path__ + "img/effective-protection-sector-vermelho.1f805121.svg";